import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { candyDataStore } from '../../../../store';
import {
  candiesArr,
  candiesArr1,
  candiesArr2,
  candiesByNames,
  TranslationKeys,
  WheelTypes,
} from '../../../../enums';

export const wheelsDictionary = {
  0: candiesArr,
  1: candiesArr1,
  2: candiesArr2,
};

const rotateObj = {
  0: 78,
  1: 18,
  2: 78,
};

export const Wheel = observer(({ wheelType = WheelTypes.first }) => {
  const t = useTranslation();
  const { resultIndex, gameAnim } = candyDataStore;
  return (
    <div
      className={`dr-wheel-circle-wrp-main ${gameAnim?.animationDuration ? 'anim' : ''}`}
      style={{
        animationDelay: gameAnim?.animationDelay,
        animationDuration: gameAnim?.animationDuration,
      }}
    >
      <div className='dr-wheel-circle-wrp'>
        <div
          className='dr-wheel-circle-inner'
          style={{ transform: `rotate(${rotateObj[wheelType]}deg)` }}
        >
          {wheelsDictionary[+wheelType].map(({ candy, index, id, isBonus, odd, isOdd }) => {
            return (
              <div className='circle-block' key={id}>
                <div className='circle-block-holder'>
                  <div className='circle-block-inner'>
                    <div
                      className={`circle-bl-small-circle ${index === resultIndex ? 'active' : ''}`}
                    />
                    <div className={`circle-bl-${isBonus ? 'bonus' : 'bet'}-item`}>
                      {candy && <img src={candiesByNames[candy]} alt='candy' />}
                    </div>
                    <p className={`circle-bl-bonus-item-${wheelType && !candy ? 'coef' : 'text'}`}>
                      {candy && isBonus ? t(TranslationKeys.Bonus) : isOdd ? `x${odd}` : ''}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});
